<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :setLoading="setLoading"
    :persistenceKey="'batch-payment-list'"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { BatchPaymentService } from "../../_services/api/suppliers/batch-payment-service";
import { FeatureStorage } from "../../_services/storage";
import TransactionListTemplate from "../../templates/transaction-list";
import {
  SuppliersTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/suppliers/suppliers-tabs";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";
import appConfig from "../../app-config";
export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Batch Payment List",
        ScreenName: "Batch Payment List",
        exportFileName: "Batch Payment List",
        selectedIndex: GetIndexByTabName("Batch Payments"),
        tabs: SuppliersTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "BatchPaymentRun",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              postProcessCallback: this.aPRemitPrepPostprocess,
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Transactions",
                message: "Get Started, Make a Transaction",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/supplier-batch-payment/create",
                visible:
                  FeatureStorage.checkPermission(
                    "BatchPaymentCommit",
                    "create"
                  ) ||
                  FeatureStorage.checkPermission("BatchPaymentSave", "create"),
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "Code",
              label: "Payment Run",
              gridDataField: "RunId",
              width: ColumnWidth.PaymentRun.width,
              showInColumnChooser: false,
              allowSorting: true,
              sortOrder: "desc",
              filterIndex: 0,
              filterLabel: "Payment Run",
              filterDataField: "RunId",
              type: "Integer",
            },
            {
              screenField: "Code",
              gridDataField: "ComputedRunId",
              visible: false,
              allowSearch: true,
              showInColumnChooser: false,
            },
            {
              screenField: "Date",
              label: "Payment Date",
              filterLabel: "Payment Date",
              dataField: "PaymentDate",
              filterDataField: "PaymentDate",
              filterIndex: 1,
              width: ColumnWidth.Date.width,
            },
            {
              screenField: "Account",
              gridDataField: "BankAccountName",
              dataField: "BankAccountName",
              label: "Bank Account",
              filterLabel: "Bank Account",
              allowHiding: false,
              minWidth: ColumnWidth.BankAccount.minWidth,
              width: "auto",
              showInColumnChooser: true,
              cellTemplate: "RecordTwoLines",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "BankAccountName",
                  },
                ],
                secondary: [
                  {
                    dataField: "BankAccountBsbAndAccount",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "BankAccountName",
                  label: "Account Name",
                  showInColumnChooser: true,
                },
                {
                  dataField: "BankAccountBsbAndAccount",
                  label: "Account Number",
                  showInColumnChooser: false,
                },
              ],
              filterIndex: 3,
              filterDataField: "BankAccountSearchText",
              dataType: "string",
              type: "Text",
            },
            {
              screenField: "ItemCount",
              label: "# Suppliers",
              dataField: "NumberOfSuppliers",
              width: ColumnWidth.Quantity.width - 30,

              allowSearch: false,
            },
            {
              screenField: "ItemCount",
              label: "# Invoices",
              dataField: "NumberOfInvoices",
              width: ColumnWidth.Quantity.width - 30,

              allowSearch: false,
            },
            {
              screenField: "Total",
              label: "Balance",
              allowSearch: false,
              gridDataField: "TotalValue",
              width: ColumnWidth.TotalAmount.width,
            },

            {
              screenField: "Total",
              allowSearch: false,
              label: "Discount",
              gridDataField: "TotalDiscount",
              width: ColumnWidth.TotalAmount.width,
            },
            {
              screenField: "Total",
              allowSearch: false,
              label: "Payment",
              gridDataField: "TotalPayment",
              width: ColumnWidth.TotalAmount.width,
            },
            {
              screenField: "DateCreated",
              dataField: "DateCreated",
              filterDataField: "DateCreated",
              filterIndex: 2,
              width: ColumnWidth.Date.width,
              minWidth: ColumnWidth.Date.minWidth,
            },
            {
              screenField: "Status",
              dataField: "Status",
              filterDataField: "Status",
              dataSourceConfig: {
                data: [
                  { key: "X", value: "Cancelled" },
                  { key: "A", value: "Open" },
                  { key: "C", value: "Completed" },
                ],
              },
              filterIndex: 5,
              cellTemplate: "Status",
              filterDefaultValue: ["A", "C"],
            },
            {
              screenField: "GridRecordEmail",
              cssClass: "padding-7",
              ReferenceNoField: "RunId",
              visible: true,
            },
            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
            },
            {
              screenField: "GridRecordPrint",
              cssClass: "padding-7",
              ReferenceNoField: "RunId",
            },
            {
              dataField: "Download",
              cellTemplate: "download-cell-template",
              fixed: true,
              fixedPosition: "right",
              caption: " ",
              label: " ",
              width: 40,
              visible: FeatureStorage.checkPermission(
                "BatchPaymentCommit",
                "create"
              ),
              makeDisabled: (data) => {
                return data.data.Status != "C" || this.isReadOnlyUser;
              },
              valueChangeCallBack: this.downloadABAFile,
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              width: 50,
              allowSearch: false,
              makeDisabled: (data) => {
                return data.data.Status !== "Open";
              },
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: "Cancel",
                      data: data,
                      visible:
                        data.data.Status == "Open" &&
                        FeatureStorage.checkPermission(
                          "BatchPaymentSave",
                          "create"
                        ),
                      // clickAction: (data) => this.cancelPayment(data),
                      clickAction: this.cancelPayment,
                    },
                    {
                      menuText: "Commit",
                      data: data,
                      visible:
                        data.data.Status == "Open" &&
                        FeatureStorage.checkPermission(
                          "BatchPaymentCommit",
                          "create"
                        ),
                      clickAction: (data) => {
                        this.navigateToBatchPaymentEdit(data);
                      },
                    },
                  ];
                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
            },
          ],
        },
      };

      return config;
    },
    isReadOnlyUser() {
      let isReadOnly = false;
      let matchedItem = FeatureStorage.getItems().filter(
        (x) =>
          x.ApplicationFeatureCode.trim() == "BatchPaymentCommit" &&
          (x.Type == "Screen" ||
            x.Type == "Settings Screen" ||
            x.Type == "Screen Setting" ||
            x.Type == "Grid Report" ||
            x.Type == "Transaction Report" ||
            x.Type == "Formatted Report")
      );
      if (
        matchedItem.length > 0 &&
        matchedItem[0].WritePermission != "Y" &&
        matchedItem[0].ReadPermission == "Y"
      )
        isReadOnly = true;

      return isReadOnly;
    },
  },
  methods: {
    downloadABAFile(e, lineData) {
      let RunId = lineData.data.RunId;

      var blobUrl = `${appConfig.VUE_APP_ROOT_API}/api/BatchPaymentRun/${RunId}/Download`;
      Object.assign(document.createElement("a"), {
        target: "_blank",
        href: blobUrl,
      }).click();
    },
    async cancelPayment({ RunId }, grid) {
      let confirmCancel = await this.$confirm(
        "Are you sure you want to Cancel?",
        "Cancel Payments"
      );
      if (!confirmCancel) return;
      this.setLoading = true;
      let payload = {
        RunId,
        Action: "X",
      };
      BatchPaymentService.cancel(payload)
        .then((res) => {
          this.setLoading = false;
          if (res) {
            grid.refresh(true);
          }
        })
        .catch((err) => {
          this.setLoading = false;
          this.displayServerError(err, "Cancellation Faild");
          this.$store.dispatch("ui/setServerError", {
            error: err,
            title: "Cancellation Faild",
          });
        });
    },
    navigateToBatchPaymentEdit({ RunId }) {
      this.$router.push({
        path: `/supplier-batch-payment/edit/${RunId}`,
      });
    },
    aPRemitPrepPostprocess(data) {
      data.forEach((element) => {
        element.DateCreated = new Date(element.DateCreated);
        if (element.Status == "A") {
          element.Status = "Open";
        }
      });
      return data;
    },
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "Status" &&
        e.column.screenField != "GridRecordEllipsisMenu" &&
        e.column.screenField != "GridRecordEmail" &&
        e.column.screenField != "GridRecordPDFView" &&
        e.column.screenField != "GridRecordPrint" &&
        e.column.dataField != "Download" &&
        e.data.Status !== "X"
      ) {
        this.onRowClicked(e, {
          view: this,
          page: "supplier-batch-payment",
          mode: "review",
          idProperty: "RunId",
          query: {
            Status: e.data.Status,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss"></style>
